import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SplitFiles from './SplitFiles';
import TaskProgress from './TaskProgress';
import Status, { STATUS_VALUE } from './Status';
import DownloadSubtitles from './DownloadSubtitles';
import DownloadTranscription from './DownloadTranscription';
import DeleteTask from './DeleteTask';
import { useQueue } from '../queue-context';
import './style.less';
const TaskPanel = ({ task, onDeleteTask, }) => {
    const queue = useQueue();
    const isReady = (task.splitFiles.length > 0
        && task.splitFiles.every((file) => file.fileTranscribed && file.beeyProjectError === false));
    const isQueued = (task.splitFiles.every((splitFile) => (queue === null || queue === void 0 ? void 0 : queue.beeyPositions.find(({ splitId }) => splitId === splitFile.id)) !== undefined));
    let status;
    if (isReady) {
        status = STATUS_VALUE.DONE;
    }
    else if (task.haveSplitErrors) {
        status = STATUS_VALUE.ERROR;
    }
    else if (isQueued) {
        status = STATUS_VALUE.WAITING;
    }
    else {
        status = STATUS_VALUE.RUNNING;
    }
    return (_jsxs("div", { className: "task-panel", children: [_jsx("div", { className: "task-panel__side", children: _jsx(Status, { status: status, size: "big" }) }), _jsxs("div", { className: "task-panel__main", children: [_jsxs("div", { className: "task-panel__header", children: [_jsx("div", { className: "task-name", children: task.projectName }), _jsxs("div", { children: [_jsx(DownloadTranscription, { task: task, isReady: isReady, format: "trsx" }), _jsx(DownloadSubtitles, { task: task, isReady: isReady }), _jsx(DownloadTranscription, { task: task, isReady: isReady, format: "docx" }), _jsx(DownloadTranscription, { task: task, isReady: isReady, format: "txt" }), _jsx(DeleteTask, { taskId: task.id, onDelete: onDeleteTask })] })] }), _jsxs("div", { className: "task-panel__body", children: [_jsx(TaskProgress, { splitFiles: task.splitFiles, task: task }), _jsx(SplitFiles, { task: task })] })] })] }));
};
export default TaskPanel;
